import bridge from '@utiles/officialStore/bridge';
export const OPEN_BROWSER = 'openBrowser';
export const OPEN_WEBVIEW = 'openWebView';
import { replaceCidByPageCid } from '@utiles/index';
export const checkIsInWebview = () => {
  return bridge.runInsdk();
};
/**
 * link:打开链接
 * openWay: 打开方式 openWebView/openBrowser
 * loginDir：是否需要登录 1:是 0:否
 * appendParams：是否要带sdk参数 1:是 0:否
 */
export const sdkOpenLink = ({
  link,
  openWay = OPEN_BROWSER,
  loginDir = '1',
  appendParams = '1'
}) => {
  if (!link) {
    return;
  }
  const newLink = replaceCidByPageCid(link);
  if (checkIsInWebview()) {
    bridge.callSdkMethod(openWay, {
      url: newLink,
      loginDir: loginDir,
      appendParams: appendParams
    });
    return;
  }
  window.open(newLink, openWay == OPEN_BROWSER ? '_blank' : '_self');
};
